module.exports = __webpack_public_path__ + "img/icb-co-elite-m.88f84a95.png";